import { render, staticRenderFns } from "./AddStickerModal.vue?vue&type=template&id=3918181e"
import script from "./AddStickerModal.vue?vue&type=script&lang=js"
export * from "./AddStickerModal.vue?vue&type=script&lang=js"
import style0 from "./AddStickerModal.vue?vue&type=style&index=0&id=3918181e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports